export default __webpack_public_path__ + "static/apple-qrcode-873c32d525e3ccdd11a0c9a62f5c9d22.png";